const complexityTooltip = {
  L: 'Low Complexity',
  M: 'Medium Complexity',
  H: 'High Complexity',
};

export { complexityTooltip };
